<template>
  <div class="group-wrap">
    <div class="content">
      <div class="search-box box">
        <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick">
        </time-search>
      </div>
      <div class="chart-content">
        <el-row :gutter="14">
          <el-col :span="16">
            <div class="chart-box">
              <div class="title">综合能源趋势图</div>
              <div class="chart" id="lineChart"></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="chart-box">
              <div class="title">综合能源占比</div>
              <div class="chart" id="pieChart"></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="chart-box table-content">
        <div class="title">综合能源整体情况</div>
        <div class="chart">
          <nk-table :columns="columns" :data="tableData"></nk-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabTree from '@/components/common/TabTree.vue'
import BtnShow from '@/components/common/BtnShow.vue'
import TimeSearch from '@/components/common/TimeSearch.vue'
import api from '@common/api/index.js'
import { findDataByParam } from '@/utils/index.js'
import handleData from '@/utils/handleData.js'
import NkTable from '@/components/common/NkTable.vue'
import ResizeContainer from '@/components/common/resizeContainer.vue'
import echarts from 'echarts'
let eleTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
]
export default {
  components: { TabTree, BtnShow, TimeSearch, NkTable, ResizeContainer },
  data () {
    return {
      unit: "",
      tabShow: true,
      viewData: [],
      viewNodeData: [],
      timeData: eleTimeData,
      selectedMeasure: {
        id: '',
        measureName: '',
      },
      selectedDate: {
        startTime: '',
        endTime: '',
      },
      columns: [
        { prop: 'name', label: '名称', show: true },
        { prop: 'Ele', label: '电（kgce）', show: true },
        { prop: 'DieselOil', label: '柴油（kgce）', show: true },
        { prop: 'Water', label: '水（kgce）', show: true },
        { prop: 'NaturalGas', label: '天然气（kgce）', show: true },
      ],
      lineCharts: null,
      pieCharts: null,
      tableData: [],
    }
  },
  created () { },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    let vm = this
    vm.drawLine()
    vm.drawPie()
    vm.changeCompany()
  },
  methods: {
    changeCompany () {
      let vm = this
      api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(this.$store.state.user.companyId, '/class/energy', null)
        .then((res) => {
          const viewData = findDataByParam('energyMeasures', true, res.data)
          const unit = findDataByParam('unit', false, res.data)
          vm.unit = unit
          this.viewData = viewData
          vm.getData()
        })
    },
    timeControlChange (e) {
      this.selectedDate = e
    },
    TimeControlClick (e) {
      let vm = this
      vm.selectedDate = e
      vm.getData()
    },
    getTreeData (data) {
      let vm = this
      vm.viewNodeData = data
    },
    tabTreeDefault (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    tabTreeClick (e) {
      let vm = this
      vm.selectedMeasure = e
      vm.getData()
    },
    async getData () {
      let vm = this
      let columns = []
      vm.loading = true
      const measures = this.viewData.map((k) => {
        columns.push({
          prop: k.key,
          label: k.label,
        })
        return {
          measureId: k.measureId,
          pointCode: k.pointCode,
          pointNumber: k.pointNumber
        }
      })
      
      columns.push({
        prop: 'total',
        label: `总量(${vm.unit})`,
        show: true,
      })
      vm.columns = columns
      let expressionName = 'ENERGY_CONSUMPTION'
      let startTime = vm.selectedDate.startTime
      let endTime = vm.selectedDate.endTime
      let dateType = vm.selectedDate.dateType
      let xData = []
      let apiName = ''
      let apiName2 = ''
      if (dateType == 'day') {
        xData = handleData.createXData('0', startTime, endTime, false)
        apiName = 'getQuantityHour2'
        apiName2 = 'getQuantityDay3'
      } else if (dateType == 'month') {
        xData = handleData.createXData('2', startTime, endTime, false)
        apiName = 'getQuantityDay3'
        apiName2 = 'getQuantityMonth2'
      } else {
        xData = handleData.createXData('5', startTime, endTime, false)
        apiName = 'getQuantityMonth2'
        apiName2 = 'getQuantityYear2'
      }

      Promise.all([
        api.quantity[apiName](
          measures,
          startTime,
          endTime
        ),
        api.quantity[apiName2](
          measures,
          startTime,
          endTime
        ),
      ]).then((resArr) => {
        // 曲线图
        let apiData = resArr[0].data
        let lineItem = apiData
        if (dateType == 'month') {
          apiData.forEach(it => {
            it.data = it.data[0]
          })
        }
        let line = {
          xAxis: {
            type: 'category',
            data: [],
          },
          legend: {
            data: [],
            textStyle: {
              color: '#bcbdbe',
            },
          },
          series: [],
        }
        for (let i = 0; i < this.viewData.length; i++) {
          let seriesItem = {
            data: [],
            type: 'bar',
            name: this.viewData[i].label,
            stack: '总量',
          }
          for (let j = 0; j < xData.length; j++) {
            if (i == 0) {
              line.xAxis.data.push(xData[j].title)
            }
            const dataItem = lineItem[i].data.find(
              (c) => new Date(c.time).getTime() == xData[j].value
            )
            if (dataItem) {
              let val =
                typeof dataItem.value == 'number'
                  ? dataItem.value.toFixed(2)
                  : '-'
              seriesItem.data.push(val)
            } else {
              seriesItem.data.push('')
            }
            // seriesItem.data.push(dataItem ? dataItem.values[i] : "");
          }
          line.legend.data.push(seriesItem.name)
          line.series.push(seriesItem)
        }
        let option = vm.lineCharts.getOption()
        option.legend = line.legend
        option.xAxis = line.xAxis
        option.series = line.series
        option.yAxis[0].name = vm.unit
        vm.lineCharts.setOption(option, true)
        //饼图
        let apiData2 = resArr[1].data
        let pie = {
          legendData: this.viewData.map(k => k.label),
          seriesData: [],
        }
        for (let i = 0;i < apiData2.length;i++) {
          const value = dateType == 'day' ? apiData2[i].data[0][0]?.value : apiData2[i].data[0].value
          let seriesItem = {
            value: typeof value == 'number' ? value.toFixed(2) : 0,
            name: this.viewData.find(k => k.pointCode == apiData2[i].pointCode && k.pointNumber === apiData2[i].pointNumber && k.measureId === apiData2[i].measureId)?.label,
          }
          pie.seriesData.push(seriesItem)
        }
        vm.pieCharts.setOption({
          legend: {
            data: pie.legendData,
          },
          series: {
            data: pie.seriesData,
          },
        })
        /* 表格数据 */
        let row = {}
        for (let i = 0; i < apiData2.length; i++) {
          const val = Array.isArray(apiData2[i].data[0]) ? apiData2[i].data[0][0]?.value : apiData2[i].data[0].value
          row[vm.columns[i].prop] =
            typeof val == 'number'
              ? val.toFixed(2)
              : '-'
        }
        let total = '-'
        for (const key in row) {
          if (key != 'name' && row[key] != '-') {
            if (!isNaN(row[key]) && total == '-') {
              total = parseFloat(row[key])
            } else {
              total += parseFloat(row[key])
            }
          }
        }
        row['total'] = total == '-' ? '-' : total.toFixed(2)
        /* 表格数据 */
        vm.tableData = [row]
      })
    },
    drawLine () {
      let vm = this
      if (this.lineCharts == null) {
        this.lineCharts = echarts.init(document.getElementById('lineChart'))
      } else {
        this.lineCharts.clear()
      }
      let option = {
        legend: {
          //   data:obj.legend.data,
          data: [],
          textStyle: {
            color: '#bcbdbe',
          },
        },
        // legend: {
        //   textStyle: {
        //     color: "#bcbdbe",
        //   },
        // },
        xAxis: {
          //   data:obj.xAxis.data,
          data: [],
          type: 'time',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#bcbdbe',
              width: 2,
            },
          },
          splitLine: { show: false },
          axisLabel: {
            textStyle: {
              color: '#bcbdbe',
            },
          },
        },
        grid: {
          x: 66,
          y: 30,
          x2: 20,
          y2: 30,
        },
        yAxis: {
          type: 'value',
          name: vm.unit,
          nameTextStyle: {
            //y轴上方单位的颜色
            color: '#878b97',
          },
          scale: true /*按比例显示*/,
          axisLine: {
            lineStyle: {
              color: '#bcbdbe',
              width: 2,
            },
          },
          axisLabel: {
            textStyle: {
              color: '#bcbdbe',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#bcbdbe'],
              width: 1,
              type: 'solid',
            },
          },
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          textStyle: {
            align: 'left',
          },
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //     magicType: {
        //       type: ["line", "bar"],
        //     }, //切换为折线图，切换为柱状图
        //   },
        //   right: "40",
        // },
        color: [
          '#00AAFF',
          '#88a80a',
          '#308145',
          '#318e96',
          '#326293',
          '#3d66c1',
          '#3a32ab',
          '#6325aa',
          '#9a1eac',
          '#b92626',
        ],
        // series: obj.series,
        series: [],
      }
      this.lineCharts.setOption(option, true)
    },
    drawPie () {
      let vm = this
      this.pieCharts = echarts.init(document.getElementById('pieChart'))
      let option = {
        title: {
          text: '',
          subtext: '',
          left: 'center',
          show: false,
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: [],
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }

      this.pieCharts.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
.group-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  //   width: 260px;
  min-width: 200px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  background: transparent;
}
.search-box {
  height: 40px;
}
.chart-content {
  margin-top: 14px;
  width: 100%;
}
.chart-box {
  width: 100%;
  height: 400px;
  border-radius: 4px;
  background: #ffffff;
  flex-flow: column;
  .title {
    height: 30px;
    line-height: 30px;
    padding: 0px 10px;
    color: #000;
    text-align: left;
    font-weight: bold;
  }
  .chart {
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px;
    box-sizing: border-box;
  }
}
.table-content {
  margin-top: 14px;
  height: 320px;
}
</style>
